export enum OauthProvider {
  // Do not change -- used in DB.
  RingCentral = 'ring_central',
}
export interface OauthStatusDto {
  connected: boolean;
}
